<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import PxyjfkBrowse from "./PxyjfkBrowse";
import PxyjfkEdit from "./PxyjfkEdit";
import PxyjfkForm from "./PxyjfkForm";
export default {
    name: "pxyjfk",
    components: { PxyjfkBrowse, PxyjfkEdit, PxyjfkForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "PxyjfkEdit";
            } else if (this.editProps.showForm === true) {
                return "PxyjfkForm";
            } else {
                return "PxyjfkBrowse";
            }
        }
    }
};
</script>
